import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xd20iii = new Equipment({
  id: 'xd20iii',
  name: 'XD20/26III',
  displayName: { main: 'XD20/26', accent: 'III' },
  path: ROUTES.xd20iiiIntro,
  assetDirectory: '/Equipment/xd20iii',
  translations,
  image: { file: 'machine.png', width: 1536, height: 1024 },
  video: null,
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '10,000 / 8,000 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'specifications.maxDiameter.label', value: 'Ø20 / Ø26', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '10,000 / 8,000', unit: 'rpm' },
    { id: 'stroke', labelKey: 'guideBushStroke', value: '240', unit: 'mm' },
    { id: 'cross', labelKey: 'specifications.crossTools.label', value: '5', unit: '' },
  ],
  features: ['guideBush', 'crossTools', 'backTools'],
  specifications: [
    { id: 'nc', value: 'Fanuc 0i-TF Plus / Siemens 828D' },
    { id: 'maxDiameter', value: 'XD20: Ø20 mm / XD26: Ø26 mm' },
    { id: 'z1Stroke' },
    { id: 'mainSpindle', value: 'XD20: 10,000 rpm · FANUC: 2.2 / 3.7 kW / XD26: 8,000 rpm · FANUC: 2.2 / 5.5 kW · Siemens: 16 kW' },
    { id: 'turningTools', value: 'XD20: 6 × (□12 mm) / XD26: 5 × (□16 mm)' },
    { id: 'frontTools', value: '5 × (ER16M, Ø25)' },
    { id: 'crossTools', value: 'XD20: 5 × (ER16) / XD26: 5 × (Ø16 mm)' },
    { id: 'crossSpeed', value: '6,000 rpm · FANUC: 1.0 kW · Siemens: 1.02 kW' },
    { id: 'offCenterTools', value: '2 × (ER16)' },
    { id: 'subSpindle', value: '8,000 rpm · FANUC: 1.5 / 2.2 kW · Siemens: 2.59 kW' },
    { id: 'backTools' },
    // Korean and Chinese catalogs specify 6,000 rpm; the English edition differs.
    { id: 'backSpeed', value: '6,000 rpm · FANUC: 1.0 kW · Siemens: 1.02 kW' },
    { id: 'dimensions', value: '2,460 × 1,290 × 1,750 mm' },
    { id: 'weight', value: '3,000 kg' },
    { id: 'power' },
    { id: 'air', value: '120–150 L/min' },
  ],
  specificationNoteKey: 'specificationNote',
  options: ['powerfulCross', 'backTools', 'backFour', 'backDrivenEight', 'offCenter', 'crossDriven', 'crossAngle'],
  optionImages: {
    powerfulCross: 'powerfulCross.jpg',
    backTools: 'backTools.jpg',
    backDrivenEight: 'backEight.png',
    offCenter: 'offCenter.png',
  },
});

export default xd20iii;
